<template lang="pug">
  .placeholder-tip
    v-icon.placeholder-tip__icon(:name="icon")
    span.placeholder-tip__text {{text}}
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'placeholder'
    },
    icon: {
      type: String,
      default: 'circle'
    }
  }
}
</script>

